import PerformanceTasksView from "@features/tools/view/performance-task-view";

const PerformanceTasks = () => {
  return <PerformanceTasksView />;
};

export default PerformanceTasks;
